import React from 'react';
import { Box, CardMedia, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(({ palette }) => ({
    productCard: {
        display: "grid",
        gridTemplateRows: "1fr 1fr",

    },
    title: {
        backgroundColor: palette.primary.main,
        color: "white",
        width: "75%",
        borderRadius: "0 5px 5px 0",
        margin: "5% 0 2% 0",
        padding: "2%",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "24px",
        lineHeight: "30px"
    },
    cardContent: {
        backgroundColor: "white",
        borderRadius: "0 0 5px 5px"
    },
    info: {
        margin: "3% 15%"
    },
    description: {
        fontWeight: 300,
        fontSize: "12px",
        lineHeight: "15px"
    }

}));

const ProductCard = (props) => {

    const classes = useStyles();

    return (
        <Box className={classes.productCard} component="div">
            <CardMedia component="img" image={props.info.img} />
            <Box component="div" className={classes.cardContent} >
                <Typography className={classes.title} variant="h6">{props.info.title}</Typography>
                <Box component="div" className={classes.info}>
                    <Typography className={classes.description} p="true" >Medidas: {props.info.sizes}</Typography>
                    <Typography className={classes.description} p="true" >Colores: {props.info.colors}</Typography>
                    <Typography className={classes.description} p="true" >Aroma: {props.info.smell}</Typography>
                    <Typography className={classes.description} p="true" >Codigo: {props.info.code}</Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default ProductCard;
